import React from 'react';
import { useTranslation } from 'react-i18next';
import { FatalErrorNotice, FATAL_ERROR_NOTICE_TYPES } from '@kallidus/common';
import ApplicationPage from '@Generic/ApplicationPage';

export default function NotAllowedPage() {
  const { t } = useTranslation();
  return (
    <ApplicationPage className='kal-error-page'>
      <FatalErrorNotice
        subHeading={t('not-allowed-page.heading')}
        type={FATAL_ERROR_NOTICE_TYPES.FORBIDDEN}
        heading={t('not-allowed-page.title')}
      />
    </ApplicationPage>
  );
}
